export const GROUP_ROLE = {
  Normal: 0, // 普通游客
  GroupMaster: 1, // 团长
  GroupMember: 2, // 团成员
}

export const GROUP_FLAG = {
  CreateFail: 0, // 开团失败
  GroupSuccess: 1, // 拼团成功
  GroupFail: 2, // 拼团失败
  GroupIng: 3, // 团进行中
  GroupEnd: 4, // 团结束（异常的结束）
}

export const GROUP_POP = {
  CREATE_GROUP_SUCCESS: 'group-buy-success-popup', // 创建团成功
  CREATE_GROUP_FAIL: 'group-fail-popup', // 创建团失败
  JOIN_GROUP_SUCCESS: 'group-buy-success-popup', // 参加团成功
  JOIN_GROUP_FAIL: 'group-fail-popup', // 参加团失败
}
